import React from 'react';
import { Link } from 'react-router-dom';
import { Camera, Globe, Send } from 'lucide-react';
import './Footer.css';
//deneme
const Footer = () => {
  return (
    <footer className="footer-wrapper">
      <div className="footer-glow"></div>
      <div className="container" style={{ textAlign: 'center' }}>
        <div className="footer-logo">
          <img src="/images/ErenisLogo.png" alt="Erenis Otomotiv" className="footer-logo-img" />
        </div>
        <div className="footer-links">
          <Link to="/" className="footer-link">Ana Sayfa</Link>
          <Link to="/araclar" className="footer-link">Filomuz</Link>
          <Link to="/hakkimizda" className="footer-link">Hakkımızda</Link>
          <Link to="/teklif-al" className="footer-link">Teklif Al</Link>
          <Link to="/iletisim" className="footer-link">İletişim</Link>
        </div>
        <div className="footer-socials">
          <a href="https://instagram.com/erenisotomotiv" target="_blank" rel="noreferrer" className="footer-social-btn"><Camera size={20} /></a>
          <a href="#" className="footer-social-btn"><Globe size={20} /></a>
          <a href="#" className="footer-social-btn"><Send size={20} /></a>
        </div>
        <p className="footer-copyright">© 2026 Erenis Otomotiv. Tüm hakları saklıdır. Kahramanmaraş.</p>
      </div>
    </footer>
  );
};

export default Footer;
